import LanguagesApi from '../../../../../core/api/LanguagesApi'

export const START_EDITING_PENDING_APPROVAL_LANGUAGES = 'START_EDITING_PENDING_APPROVAL_LANGUAGES'
export const STOP_EDITING_PENDING_APPROVAL_LANGUAGES = 'STOP_EDITING_PENDING_APPROVAL_LANGUAGES'
export const CANCEL_EDITING_PENDING_APPROVAL_LANGUAGES = 'CANCEL_EDITING_PENDING_APPROVAL_LANGUAGES'
export const PENDING_APPROVAL_ADVISER_LANGUAGE_PREFERENCES_FETCHED_LANGUAGES = 'PENDING_APPROVAL_ADVISER_LANGUAGE_PREFERENCES_FETCHED_LANGUAGES'
export const PENDING_APPROVAL_ADVISER_LANGUAGE_PREFERENCES_LANGUAGE_SELECTED_CHANGED = 'PENDING_APPROVAL_ADVISER_LANGUAGE_PREFERENCES_LANGUAGE_SELECTED_CHANGED'

const languagesApi = new LanguagesApi()

export const startEditingLanguages = () => ({
  type: START_EDITING_PENDING_APPROVAL_LANGUAGES
})

export const cancelEditingLanguages = () => ({
  type: CANCEL_EDITING_PENDING_APPROVAL_LANGUAGES
})

export function fetchLanguages () {
  const request = languagesApi.fetchingLanguages()

  return (dispatch) => {
    request.then(function (response) {
      dispatch(languagesApi.handleResponse(PENDING_APPROVAL_ADVISER_LANGUAGE_PREFERENCES_FETCHED_LANGUAGES, response))
    })
  }
}

export const languageSelectedChanged = (language) => ({
  type: PENDING_APPROVAL_ADVISER_LANGUAGE_PREFERENCES_LANGUAGE_SELECTED_CHANGED,
  language
})

export const stopEditingLanguages = () => ({
  type: STOP_EDITING_PENDING_APPROVAL_LANGUAGES
})
